import { PREVIOUS_DAY_STATUS } from "../constants.dashboard";
import { InvoiceHistoryItem } from "../handlers/getInvoiceHistory";

interface PaidRunWindow {
  minMonths?: number;
  maxMonths: number;
}

const MONTHLY_INTERVAL = "month";

const toPlanKey = (plans: string[]) =>
  [...plans].sort((a, b) => a.localeCompare(b)).join("|");

/** Newest-first unbroken run of paid monthly renewals on the current plan; empty outside `minMonths`–`maxMonths`. */
export function computePaidRun(
  invoices: InvoiceHistoryItem[],
  { minMonths = 0, maxMonths }: PaidRunWindow,
): InvoiceHistoryItem[] {
  if (invoices.length === 0) {
    return [];
  }

  const currentPlans = toPlanKey(invoices[0].plans);

  const planChangeIndex = invoices.findIndex(
    (invoice) =>
      invoice.interval !== MONTHLY_INTERVAL ||
      toPlanKey(invoice.plans) !== currentPlans,
  );
  const samePlanInvoices =
    planChangeIndex === -1 ? invoices : invoices.slice(0, planChangeIndex);

  const runStartIndex = samePlanInvoices.findIndex(
    (invoice) =>
      invoice.previous_day_status !== PREVIOUS_DAY_STATUS.ACTIVE_PAID,
  );

  const runLength =
    runStartIndex === -1 ? samePlanInvoices.length : runStartIndex + 1;
  const isInWindow = runLength >= minMonths && runLength <= maxMonths;

  return isInWindow ? samePlanInvoices.slice(0, runLength) : [];
}
